import { Component, ViewChild } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as _ from 'lodash';

@Component({
    templateUrl: './demographics.component.html',
    standalone: false
})
export class DemographicsComponent {
  @ViewChild('demographicsForm') form;

  varTrack;
  varLOB;
  varFirstTime;
  varWelcomeReception;
  varFinalNightConcert;
  varMorningWorkout;
  varDonation;
  donationvalues;
  varDonationAmount;
  varDonationOther;
  isRegComplete;
  varDesignatedSpeaker;
  varSponsorPreConference;
  sponsordayvalues;
  timesattending;
  varPastEventsAttend;
  varSupplierRole;
  varAffiliation;
  varAffiliationOther;
  affiliationlist;
  firstTime;
  firstTimeValue;
  whyAttend;
  whyAttendValue;
  bestFeatureChecked;
  varVeteran;
  veteranOther;
  yesno;
  veteranlist;
  varFirstresponder;
  firstresponderlist;
  varFirstresponderOther;
  varVeteranOther;
  varLPLAStockholder;
  varContribute;
  contributeResponses;
  varContribution;
  contributiondropdownlist;
  varInitials;
  stateNetwork;
  careerStageList;
  varCareerStage;
  learningTopicOne;
  learningTopicTwo;
  learningTopicThree;
  challengeOne;
  challengeTwo;
  challengeThree;
  mostExcited;
  SMStext;
  SMSprovider;
  providervalues;
  SMSproviderother;
  ContactConsent;
  varpromotionalemail;
  isSubmitting: boolean;
  attendee: any;
  enrollment;
  varSessionDesignation;

  emailFormArray: Array<any> = [];
  otherChecked: boolean;

  isFormCompleted=false;
  questions: Question[];

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService
  ) {
    this.enrollment = this.registrationService.getEnrollment({});
    this.attendee = this.registrationService.getAttendee({});

    this.varTrack = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTrack.ID,
      {}
    );

    this.varLOB = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLOB.ID,
      {}
    );

    this.varFirstTime = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstTime.ID,
      {}
    );
    
    this.varSupplierRole = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSupplierRole.ID,
      {}
    );    
    // this.varPreConference = registrationService.getVariable(
    //   this.attendee,
    //   variablesService.VARIABLE.varPreConference.ID,
    //   {}
    // );

    this.varWelcomeReception = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varWelcomeReception.ID,
      {}
    );

    this.varFinalNightConcert = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFinalNightConcert.ID,
      {}
    );

    // this.varMorningWorkout = registrationService.getVariable(
    //   this.attendee,
    //   variablesService.VARIABLE.varMorningWorkout.ID,
    //   {}
    // );

    this.varDonation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonation.ID,
      {}
    );

    this.donationvalues = variablesService.donationvalues;


    this.varDonationAmount = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonationAmount.ID,
      {}
    );

    this.varDonationOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDonationOther.ID,
      {}
    );

    this.varDesignatedSpeaker = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varDesignatedSpeaker.ID,
      {}
    );

    this.varSponsorPreConference = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSponsorPreConference.ID,
      {}
    );
    

    // this.varBreakfast = registrationService.getVariable(
    //   this.attendee,
    //   variablesService.VARIABLE.varBreakfast.ID,
    //   {}
    // );
    
    this.varPastEventsAttend = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varPastEventsAttend.ID,
      {}
    );

    this.varAffiliation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varAffiliation.ID,
      {}
    );
    this.varAffiliationOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varAffiliationOther.ID,
      {}
    );
    this.SMStext = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSMSConsent.ID,
      {}
    );
    this.stateNetwork = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varStateNetwork.ID,
      {}
    );
    this.SMSprovider = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varCellProvider.ID,
      {}
    );
    this.SMSproviderother = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.SMSproviderother.ID,
      {}
    );
    if (this.SMSprovider.Value === 'ATT') {
      this.SMSprovider.Value = 'AT&T';
    }
    this.varVeteran = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varVeteran.ID,
      {}
    );
    this.veteranlist = _.cloneDeep(variablesService.veteranlist);
    
    this.varVeteranOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varVeteranOther.ID,
      {}
    );

    this.varFirstresponder = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstresponder.ID,
      {}
    );
    this.firstresponderlist = _.cloneDeep(variablesService.firstresponderlist);
    
    this.varFirstresponderOther = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varFirstresponderOther.ID,
      {}
    );
    this.varLPLAStockholder = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLPLAStockholder.ID,
      {}
    );

    this.varContribute = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varContribute.ID,
      {}
    );

    this.varContribution = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varContribution.ID,
      {}
    );

    this.varInitials = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varInitials.ID,
      {}
    );
    
    this.varpromotionalemail = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varpromotionalemail.ID,
      {}
    );


    this.careerStageList = variablesService.careerStageList;
    this.varCareerStage = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varCareerStage.ID,
      {}
    );

    this.learningTopicOne = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLearn1.ID,
      {}
    );

    this.learningTopicTwo = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLearn2.ID,
      {}
    );

    this.learningTopicThree = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varLearn3.ID,
      {}
    );

    this.challengeOne = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varChallenge1.ID,
      {}
    );

    this.challengeTwo = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varChallenge2.ID,
      {}
    );

    this.challengeThree = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varChallenge3.ID,
      {}
    );

    this.mostExcited = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varMostExcited.ID,
      {}
    );

    this.varSessionDesignation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varSessionDesignation.ID,
      {}
    );

    this.yesno = _.cloneDeep(variablesService.yesno);
    this.contributeResponses = [
        {display: "Yes", value: 'Yes'},
        {display: "I am already a PAC Member", value: 'PAC Member'},
        {display: "No", value: 'No'},
      ];

    this.providervalues = _.cloneDeep(variablesService.providervalues);
    this.contributiondropdownlist = _.cloneDeep(variablesService.contributiondropdownlist);

    if (this.varTrack.Value === 'Benefit Advisor' || this.varTrack.Value==='Non-Benefit Advisor' || this.varTrack.Value==='Home Office') {
      if (this.varContribution.Value) {
        if (this.varContribution.Value === "$250" || this.varContribution.Value === "$500" || this.varContribution.Value === "$1000" || this.varContribution.Value === "$2500"
        || this.varContribution.Value === "$5000") {
          this.enrollment.$mtccontributetemp = this.varContribution.Value;
        } else if (this.varContribution.Value == "250" && this.enrollment.$mtccontributetemp !== "Other"){
        // Prevent autofilling 'Other' if user backtracks from page before ever picking from dropdown
        } else {
          this.enrollment.$mtccontributetemp = "Other";
        }
      } else {
        this.varContribution.Value = "250";
      }
    }

    if(this.varLOB.Value === 'IS') {
      this.affiliationlist = [
        {display: "Financial Institution - Advisor", value: 'Financial Institution - Advisor'},
        {display: "Financial Institution - Program Manager", value: 'Financial Institution - Program Manager'},
        {display: "Financial Institution - Program Manger & Advisor", value: 'Financial Institution - Program Manger and Advisor'},
        {display: "Financial Institution - Sales Manager", value: 'Financial Institution - Sales Manager'},
        {display: "Financial Institution - Executive Management", value: 'Financial Institution - Executive Management'},
        {display: "Other", value: 'Other'}

      ];
    }else {
      this.affiliationlist = [
        {display: "LPL RIA - Advisor", value: 'LPL RIA - Advisor'},
        {display: "LPL RIA - Linsco / Employee Advisor", value: 'LPL RIA - Linsco / Employee Advisor'},
        {display: "LPL RIA - Strategic Wealth Services", value: 'LPL RIA - Strategic Wealth Services'},
        {display: "LPL RIA - Field Management", value: 'LPL RIA - Field Management'},
        {display: "LPL RIA - Admin or Office Staff", value: 'LPL RIA - Admin or Office Staff'},
        {display: "LPL RIA - Management Team", value: 'LPL RIA - Management Team'},
        {display: "LPL RIA Enterprise - Advisor", value: 'LPL RIA - Advisor'},
        {display: "LPL RIA Enterprise - Management", value: 'LPL RIA - Management'},
        {display: "LPL RIA Enterprise - Owner / Management", value: 'LPL RIA - Owner / Management'},
        {display: "RIA Hybrid Enterprise - Advisor", value: 'RIA Hybrid Enterprise - Advisor'},
        {display: "RIA Hybrid Enterprise - Management", value: 'RIA Hybrid Enterprise - Management'},
        {display: "RIA Hybrid Enterprise - Owner / Management", value: 'RIA Hybrid Enterprise - Owner / Management'},
        {display: "RIA Hybrid - Advisor", value: 'RIA Hybrid - Advisor'},
        {display: "RIA Hybrid - Owner / Advisor", value: 'RIA Hybrid - Owner / Advisor'},
        {display: "RIA Hybrid - Admin or Office Staff", value: 'RIA Hybrid - Admin or Office Staff'},
        {display: "RIA Hybrid - Management Team", value: 'RIA Hybrid - Management Team'},
        {display: "RIA Only - Advisor", value: 'RIA Only - Advisor'},
        {display: "RIA Only - Owner / Advisor", value: 'RIA Only - Owner / Advisor'},
        {display: "RIA Hybrid - Admin or Office Staff", value: 'RIA Hybrid - Admin or Office Staff'},
        {display: "RIA Hybrid - Management Team", value: 'RIA Hybrid - Management Team'},
        {display: "RIA Hybrid - Strategic Wealth Services", value: 'RIA Hybrid - Strategic Wealth Services'},
        {display: "Other", value: 'Other'}
      ];    
    }

    this.timesattending = variablesService.timesattending;
    this.questions = [
      {
        id: 1,
        title: 'What are you eager to learn more about at Focus?',
        maxSelections: 3,
        options: [
          { id: 1, text: 'Growing and expanding my business', selected: false },
          { id: 2, text: 'Refining my wealth and investment management approach', selected: false },
          { id: 3, text: 'Driving efficiency in my business', selected: false },
          { id: 4, text: 'Incorporating more technology into my business', selected: false },
          { id: 5, text: 'Planning for an acquisition or future business succession', selected: false }
        ],
        rankedOptions: [],
        hasError: false
      },
      {
        id: 2,
        title: 'What is one challenge you\'d like to solve in your business?',
        maxSelections: 3,
        options: [
          { id: 1, text: 'Reclaim my time', selected: false },
          { id: 2, text: 'Need more dollars to grow', selected: false },
          { id: 3, text: 'Need to offer my clients more services (planning, estate planning, tax planning, etc.)', selected: false },
          { id: 4, text: 'Need to focus on managing the business', selected: false },
          { id: 5, text: 'Need more staff', selected: false }
        ],
        rankedOptions: [],
        hasError: false
      }
    ];

    // Initialize rankedOptions based on existing variable values
    let learningTopicsInitializer = [this.learningTopicOne.Value, this.learningTopicTwo.Value, this.learningTopicThree.Value];
    learningTopicsInitializer.forEach(topic => {
      if (topic != "" && topic != undefined) {
        const option = this.questions[0].options.find(opt => opt.text === topic);
        if (option) {
          this.toggleOption(this.questions[0], option);
        }
    }});
    let challengesInitializer = [this.challengeOne.Value, this.challengeTwo.Value, this.challengeThree.Value];
    challengesInitializer.forEach(challenge => {
      if (challenge != "" && challenge != undefined) {
        const option = this.questions[1].options.find(opt => opt.text === challenge);
        if (option) {          
          this.toggleOption(this.questions[1], option);
        }
      }
    });

  }


    // Handle checkbox selection for ranking questions
  toggleOption(question: Question, option: SurveyOption): void {
    const selectedCount = question.options.filter(opt => opt.selected).length;
    question.hasError = false;
    
    if (!option.selected && selectedCount >= (question.maxSelections || 3)) {
      // Already at max selections
      return;
    }
    
    option.selected = !option.selected;
    this.updateRankedList(question);
  }

  // Update the ranked list based on selected options
  updateRankedList(question: Question): void {
    const selected = question.options.filter(opt => opt.selected);
    
    // Preserve existing order for items that remain selected
    const existingRanked = question.rankedOptions || [];
    const newRanked: SurveyOption[] = [];
    
    // Keep items that are still selected in their current order
    existingRanked.forEach(item => {
      if (selected.find(s => s.id === item.id)) {
        newRanked.push(item);
      }
    });
    
    // Add newly selected items at the end
    selected.forEach(item => {
      if (!newRanked.find(r => r.id === item.id)) {
        newRanked.push(item);
      }
    });
    
    question.rankedOptions = newRanked;
    this.updateVariablesFromRankedList(question);
  }

  updateVariablesFromRankedList(question: Question): void {
    if (question.id === 1) {
      this.learningTopicOne.Value = question.rankedOptions[0]?.text || "";
      this.learningTopicTwo.Value = question.rankedOptions[1]?.text || "";
      this.learningTopicThree.Value = question.rankedOptions[2]?.text || "";
    } else if (question.id === 2) {
      this.challengeOne.Value = question.rankedOptions[0]?.text || "";
      this.challengeTwo.Value = question.rankedOptions[1]?.text || "";
      this.challengeThree.Value = question.rankedOptions[2]?.text || "";
    }

  }

  // Handle drag and drop reordering
  dropTopic(event: CdkDragDrop<SurveyOption[]>, question: Question): void {
    if (question.rankedOptions) {
      moveItemInArray(question.rankedOptions, event.previousIndex, event.currentIndex);
      this.updateVariablesFromRankedList(question);
    }
  }

    // Handle drag and drop reordering
  dropChallenge(event: CdkDragDrop<SurveyOption[]>, question: Question): void {
    if (question.rankedOptions) {
      moveItemInArray(question.rankedOptions, event.previousIndex, event.currentIndex);
      this.updateVariablesFromRankedList(question);
    }
  }

  // Check if an option can be selected (not at max)
  canSelectMore(question: Question): boolean {
    const selectedCount = question.options.filter(opt => opt.selected).length;
    return selectedCount < (question.maxSelections || 3);
  }

  // Get count of selected items
  getSelectedCount(question: Question): number {
    return question.options.filter(opt => opt.selected).length;
  }

  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted=true;
    this.isSubmitting = true;
    if (this.varTrack.Value === 'Benefit Advisor'  || this.varTrack.Value==='Non-Benefit Advisor' || this.varTrack.Value==='Home Office') {
      if (this.enrollment.$mtccontributetemp && this.enrollment.$mtccontributetemp !== "Other") {
        this.varContribution.Value = this.enrollment.$mtccontributetemp;
      }
    }

    if (this.varContribute.Value !== 'Yes') {
      this.varContribution.Value = "";
      this.varInitials.Value = "";
      this.enrollment.$mtccontributetemp = "";
    }

    if (this.SMStext.Value === 'No') {
      this.SMSprovider.Value = "";
      this.SMSproviderother = "";
    }
    if (this.SMSprovider.Value !== 'Other') {
      this.SMSproviderother = "";
    }

    if (this.varDonation.Value === "No") {
      this.varDonationAmount.Value = "";
      this.varDonationOther.Value = "";
    }

    if (this.varTrack.Value === 'Benefit Advisor' || this.varTrack.Value==='Non-Benefit Advisor' || this.varTrack.Value==='Commonwealth Client') {
      if(this.attendee.$mtcOptOut) {
        this.varpromotionalemail.Value = "Opted out"
      } else {
        this.varpromotionalemail.Value = "Opted in"
      }
    }

    if (this.varDesignatedSpeaker.Value !== 'Yes' && this.varSessionDesignation.Value !== undefined && this.varSessionDesignation.Value !== "") {
      this.varSessionDesignation.Value = "";
    }

    let rankingsValid = true;
    if (this.varTrack.Value === 'Benefit Advisor'  || this.varTrack.Value==='Non-Benefit Advisor' ||  this.varTrack.Value === 'Commonwealth Client') {
      this.questions.forEach(question => {
        if (question.rankedOptions.length < question.maxSelections) {
          question.hasError = true;
          rankingsValid = false;
        } else {
          question.hasError = false;
        }
      });
    }

    if (form.valid && rankingsValid) {
      this.navigationService.forward();
    } else{
      this.isSubmitting = false;
    }
  }
}

interface SurveyOption {
  id: number;
  text: string;
  selected: boolean;
}

interface Question {
  id: number;
  title: string;
  maxSelections?: number;
  options: SurveyOption[];
  rankedOptions?: SurveyOption[];
  hasError: boolean;
}
